/**
 * @description Класс отвечает за логику работы тела формы пассажира (полей)
 * реализует методы сбора, установки и валидации данных.
 * */
class PassengerForm {
    constructor ($wrapper, options) {
        var that = this;

        // DOM
        that.$wrapper = $wrapper;
        that.category = options["category"];

        //
        that.form_controller = options["form_controller"];

        // OPTIONS
        that.modals = options['modals'];
        that.locales = options['locales'];
        that.departure_date = options['departure_date'];
        that.departure_date_last = options['departure_date_last'];
        that.passenger_index = options['passenger_index'];
        that.contact_documents = options['contact_documents'] || [];
        that.is_infant = options['is_infant'];
        that.getSsrs = options['getSsrs'] || function () { return []; };
        that.getMaxSsrIndex = options['getMaxSsrIndex'] || function () { return 0; };

        // INPUTS
        that.$inputs = that.$wrapper.find('.js-input');
        that.$inputs_name = that.$wrapper.find('.js-name');
        that.$last_name_input = that.$wrapper.find('.js-last-name');
        that.$first_name_input = that.$wrapper.find('.js-first-name');
        that.$middle_name_input = that.$wrapper.find('.js-middle-name');
        that.$middle_name_checkbox = that.$wrapper.find('.js-checkbox-switch');
        that.$input_citizenship = that.$wrapper.find('.js-citizenship');
        that.$input_doc_code = that.$wrapper.find('.js-doc-code');
        that.$input_doc_number = that.$wrapper.find('.js-doc-number');
        that.$doc_expire_wrapper = that.$wrapper.find('.js-doc-expire-wrapper');
        that.$input_doc_expire = that.$doc_expire_wrapper.find('.js-input-expire');
        that.$input_birthday = that.$wrapper.find('.js-birthday');
        that.$sex = that.$wrapper.find('.js-select-sex');
        that.$sex_checkboxes = that.$sex.find('.js-input-sex');
        that.$citizenship_select = that.$wrapper.find('.js-citizenship-select');
        that.$doc_select = that.$wrapper.find('.js-doc-select');
        that.$inputs_select = that.$wrapper.find('.js-input-select');
        
        that.inputs_lock = [
            that.$inputs,
            that.$inputs_select.find('input'),
            that.$wrapper.find('.js-checkbox-switch'),
            that.$wrapper.find('.js-reset'),
            that.$wrapper.find('.js-ssrs-button')
        ];

        that.$ssrs_button = that.$wrapper.find('.js-ssrs-button');
        that.$ssrs_button_label = that.$ssrs_button.find('.js-ssrs-button-label');
        that.$reset_button = that.$wrapper.find('.js-reset');

        // CONST
        that.is_modal = (typeof options["is_modal"] === "boolean" ? options["is_modal"]  : false);
        that.class = {
            is_active: 'is-active',
            reset_input: 'js-reset-input',
            hidden: 'hidden',
            error: 'error',
            input_state_is_disabled: 'js-state-is-disabled',
            document_item: 'js-document-item'
        };

        // DYNAMIC VARS
        that.passenger_form_ssrs = null;
        that.doc_code_perv_value = that.$input_doc_code.val() || null;
        that.ssrs_data = [];

        // INIT
        that.init();
    };

    init = function () {
        var that = this;
        
        //
        that.__initPassengerDataDrawer();
        //
        that.__initSsrs();
        //
        that.__initReset();
        //
        that.__initContactDocuments();
        //
        that.__initDocumentsListDrawer();
        //
        that.__initFields();
        //
        that.__initFieldHandlers();
        //
        that.__setupDocListByCitizenship(that.$input_citizenship.val());
    };

    // Public methods, called from parents

    isValid = function (departure_date, departure_date_last) {
        var that = this;
        
        return that.__validate(departure_date, departure_date_last);
    }
    
    inputsLock = function () {
        var that = this;

        that.inputs_lock.forEach(function ($inputs){
            $inputs.each(function () {
                var $input = $(this);
                
                if ($input.prop('disabled')) {
                    $input.addClass(that.class.input_state_is_disabled);
                }
                $input.prop('disabled', true);
            });
        });
    }

    inputsUnlock = function () {
        var that = this;

        that.inputs_lock.forEach(function ($inputs){
            $inputs.each(function () {
                var $input = $(this);
                
                if (!$input.hasClass(that.class.input_state_is_disabled)) {
                    $input.prop('disabled', false);
                } else {
                    $input.removeClass(that.class.input_state_is_disabled);
                }
            });
        });
    }

    isValidAdultAge = function (departure_date) {
        var that = this,
            birthday = that.$input_birthday.val(),
            birthday_formatted = dayjs(birthday, 'DD.MM.YYYY', true),
            departure_date_formatted = dayjs(departure_date, 'YYYY-MM-DD HH:mm:ss', true),

            // https://day.js.org/docs/en/display/difference
            date_diff = departure_date_formatted.diff(birthday_formatted, 'year', true),

            years_min = 18,
            is_valid = true;

        if (date_diff <= years_min) {
            is_valid = false;
        }

        return is_valid;
    };

    getBirthday = function () {
        const that = this;
        return that.$input_birthday.val();
    };

    getData() {
        const that = this;

        let sex = that.$sex_checkboxes.filter(":checked:first").val();
        sex = (sex ? sex : "");

        return {
            "nationality": that.$input_citizenship.val(),
            "doc_code": that.$input_doc_code.val(),
            "doc_number": that.$input_doc_number.val(),
            "doc_expire": that.$input_doc_expire.val(),
            "sex": sex,
            "lastname": that.$last_name_input.val(),
            "firstname": that.$first_name_input.val(),
            "middlename": that.$middle_name_input.val(),
            "no_middlename": (that.$middle_name_checkbox[0].checked ? "1" : "0"),
            "birthdate": that.getBirthday()
        };
    }

    /**
     * @param {Object} data
     * @param {Boolean?} validate
     * */
    setData(data, validate) {
        validate = (typeof validate === "boolean" ? validate : true);

        var that = this;

        // Очищаем все значения
        that.__reset();

        // Устанавливаем значения полей
        fillDocumentFields();
        fillPassengerFields();

        // Валидируем
        if (validate) {
            that.__validate(that.departure_date, that.departure_date_last);
        }

        //

        function fillDocumentFields() {
            var $citizenship_list = that.$citizenship_select.find('.select-options .list'),
                $citizenship_code = $citizenship_list.find("[data-value='" + data['nationality'] + "']"),
                $doc_type_list = that.$doc_select.find('.select-options .list'),
                $doc_code = $doc_type_list.find("[data-value='" + data['doc_code'] + "']");

            if ($citizenship_code && $citizenship_code.length) {
                UISelect.prototype.selectOption(that.$citizenship_select, $citizenship_code);
            }

            if ($doc_code && $doc_code.length) {
                UISelect.prototype.selectOption(that.$doc_select, $doc_code);
            }

            that.$input_doc_number.val(data['doc_number']);
            UIInput.prototype.setNotEmpty(that.$input_doc_number);

            if (data['doc_expire'] && !that.$input_doc_expire.is(':disabled')) {
                that.$input_doc_expire.val(data['doc_expire']);
                UIInput.prototype.setNotEmpty(that.$input_doc_expire);
            }
        }

        function fillPassengerFields() {
            const { $last_name_input, $first_name_input, $middle_name_input, $middle_name_checkbox, $sex_checkboxes } = that;

            let sex = null;
            switch (data.sex) {
                case 'm':
                case 'male':
                    sex = 'male';
                    break;
                case 'f':
                case 'female':
                    sex = 'female';
                    break;
            }
            $last_name_input.val(data['lastname']);
            UIInput.prototype.setNotEmpty($last_name_input);

            $first_name_input.val(data['firstname']);
            UIInput.prototype.setNotEmpty($first_name_input);

            if (!!data['middlename']) {
                $middle_name_input.val(data['middlename']);
                UIInput.prototype.setNotEmpty($middle_name_input);
                $middle_name_checkbox.prop('checked', false).change();
            }

            if (+data['no_middlename']) {
                $middle_name_checkbox.prop('checked', true).change();
            }

            $sex_checkboxes.each(function() {
                const $checkbox = $(this);
                $checkbox.prop('checked', data.sex && $checkbox.val() === data.sex);
            });

            that.$input_birthday.val(data['birthdate']);
            UIInput.prototype.setNotEmpty(that.$input_birthday);
        }
    }

    /**
     * @param {Array?} ssrs_data
     * */
    setSSRS(ssrs_data = []) {
        var that = this,
            max_ssr_index = that.getMaxSsrIndex();

        that.__removeSsrsFromPassenger();

        // переносим информацию полей из модалки в скрытые поля страницы
        // и вызываем обновление формы
        ssrs_data.forEach( function(input_data) {
            max_ssr_index = max_ssr_index + 1;
            that.__addSsrToPassenger(input_data, max_ssr_index);
        });

        // Для десктопной формы в DOM тригерим ивент, который сохранит данные в Store
        const $form = that.$wrapper.closest('form');
        if ($form.length) { 
            $form.trigger("input");
        }

        that.__updateSsrButton(ssrs_data);

        that.ssrs_data = ssrs_data;
    }

    // Init methods

    __initPassengerDataDrawer = function () {
        var that = this,
            $button = that.$wrapper.find('.js-saved-data-drawer-button');

        $button.on('click', function (e) {
            e.preventDefault();
            if ($.sa.is_tablet()) {
                var $drawer_content = that.$wrapper.find('.js-saved-data-drawer-content').clone(),
                    $drawer_header = that.$wrapper.find('.js-saved-data-drawer-header').html();

                $.uiDrawerBottom({
                    header_contrast: true,
                    header: $drawer_header,
                    content: $drawer_content,
                    onBgClick: function (uiDrawerBottom) {
                        uiDrawerBottom.close();
                    }
                });
            }
        });
    };
    
    __initSsrs = function () {
        var that = this;

        /** @type {PassengerFormSsrs} */
        that.passenger_form_ssrs = new PassengerFormSsrs({
            $wrapper: that.$wrapper,
            modals: that.modals['ssrs'],
            departure_date: that.departure_date,
            onConfirm: function(ssrs_data) {
                return that.setSSRS(ssrs_data);
            },
            getSsrs: function() {
                let result = [];

                if (that.is_modal && that.ssrs_data.length) {
                    result = that.ssrs_data;
                } else {
                    result = that.getSsrs();
                }

                return result;
            }
        })

        if (that.is_infant) {
            that.$ssrs_button.hide();
            return;
        }

        that.$ssrs_button.on('click', function (e) {
            e.preventDefault;

            that.passenger_form_ssrs.render();
        });

        var ssrs = that.getSsrs();

        that.__updateSsrButton(ssrs);
        that.__restoreSsrsFromPassenger(ssrs);
    };

    // пересоздаем ssrs в пассажире, чтобы не удалялись сами
    __restoreSsrsFromPassenger = function (ssrs) {
        var that = this;

        ssrs.forEach(function (input_data) {
            that.__addSsrToPassenger(input_data);
        });
    };

    __removeSsrsFromPassenger = function () {
        var that = this,
            class_name = that.passenger_form_ssrs.getSsrClassName();
        
        that.$wrapper.find("input" + class_name).remove();
    }

    __addSsrToPassenger = function (input_data, ssr_index) {
        var that = this,
            class_name = that.passenger_form_ssrs.getSsrClassName().slice(1),
            input_name = ssr_index ? input_data.name.replace(/\d+/g, ssr_index) : input_data.name,
            $checkbox = $("<input />", {
                class: class_name,
                type: "hidden",
                name: input_name,
                value: input_data.value
            }),
            $hidden = $("<input />", {
                class: class_name,
                type: "hidden",
                name: input_name.replace('type', 'passenger_index'),
                value: that.passenger_index
            });

        that.$wrapper.append($checkbox);
        that.$wrapper.append($hidden);
    }

    __updateSsrButton = function (ssrs) {
        var that = this;

        setTimeout(function () {
            var button_label = ssrs.length > 0 && that.passenger_form_ssrs.__isAllowed() ? 'edit' : 'add';
            that.$ssrs_button_label.text(that.$ssrs_button.data(button_label));
        }, 50);
    }

    __initReset = function () {
        var that = this;

        that.$reset_button.on('click', function (e) {
            e.preventDefault;
            that.__reset();
        });
    };

    __initFields = function () {
        var that = this,
            $input_checkbox_switch = that.$wrapper.find('.js-checkbox-switch');

        that.__setupDateMask(that.$input_birthday, 'birthday');

        that.__setupNameInputsMask();

        that.__setupDocNumberMask();

        that.__initDocCodeField();

        that.__disableTextByCheckbox($input_checkbox_switch);
    };

    __initDocCodeField = function () {
        var that = this;

        that.$input_doc_code.on('input', function () {
            var value = that.$input_doc_code.val();
            
            if (value === that.doc_code_perv_value) {
                return;
            }
            
            that.doc_code_perv_value = value;
                
            switch (value) {
                case 'PS':
                case 'SR':
                    that.__setupNameInputsMask('cyr');
                    that.__setupDocNumberMask();
                    that.__togglePspExpireField(false);
                    UIInput.prototype.clearError(that.$input_doc_expire);
                    break;
                case 'PSP':
                case 'NP':
                case 'ZA':
                    that.__setupNameInputsMask('lat');
                    that.__setupDocNumberMask();
                    that.__togglePspExpireField(true);
                    UIInput.prototype.clearError(that.$input_doc_expire);
                    break;
            }
        });
    };

    __initFieldHandlers = function () {
        var that = this;

        that.$inputs.each(function () {
            var $input = $(this);

            $input.on('input', function () {
                that.__initInputInput($input);
            });

            $input.on('blur', function () {
                that.__initInputBlur($input);
            });
        });

        that.$inputs_select.each(function (){
            var $select = $(this),
                $select_input = $select.find('.select-input input');

            $select_input.on('blur', function (){
                that.__initInputBlur($select);
            });
        });
    };

    // Contact documents

    __initContactDocuments = function () {
        var that = this;

        that.__initContactDocumentsHandlers(that.$wrapper, null);
    }

    __initContactDocumentsHandlers = function ($wrapper, drawer) {
        var that = this;

        $wrapper.on('click', '.' + that.class.document_item, function () {
            var $button = $(this);
            var document_id = $button.data('id');
            that.__useContactDocumentById(document_id);
            
            if (drawer) {
                drawer.close();
                return;
            }

            var $dd_wrapper = $button.closest('.js-dd-desktop');

            if ($dd_wrapper.length && $.sa.is_desktop()) {
                $dd_wrapper.find('.js-dd-button').trigger('click');
            }
        });
    };

    __initDocumentsListDrawer = function () {
        var that = this,
            $button = that.$wrapper.find('.js-documents-drawer-button');

        $button.on('click', function (e) {
            e.preventDefault();

            if ($.sa.is_tablet() || $.sa.is_mobile()) {
                var $drawer_content = that.$wrapper.find('.js-contact-documents-list').clone();

                $.uiDrawer({
                    position: 'bottom',
                    size: 'small',
                    header_contrast: true,
                    header_title: $.sa.locales['select_document'],
                    content: $drawer_content,
                    custom_class: 'documents-list-drawer',
                    onOpen: function ($drawer_wrapper, drawer) {
                        $drawer_wrapper.find('.is-hidden').removeClass('is-hidden');
                        that.__initContactDocumentsHandlers($drawer_wrapper, drawer);
                    }
                });
            }
        });
    };

    __useContactDocumentById = function (document_id) {
        if (!document_id) {
            return;
        }

        var that = this,
            contact_document = that.contact_documents[document_id];

        if (!contact_document) {
            return;
        }

        that.__useContactDocument(contact_document);
    };

    __useContactDocument(document) {
        const that = this;

        const data = {
            nationality: document["nationality"],
            doc_code: document["doc_code"],
            doc_number: document["doc_number"],
            doc_expire: $.sa.parseDatetime(document["doc_expire"]).day.input,

            sex: document["sex"],
            lastname: document["lastname"],
            firstname: document["firstname"],
            middlename: document["middlename"],
            no_middlename: document["no_middlename"],
            birthdate: $.sa.parseDatetime(document["birthdate"]).day.input
        };

        return that.setData(data);
    }

    //

    __setupDateMask = function ($input, validation_field = null) {
        var that = this,
            complete = false,
            $input_error_symbol = $input.data('error-symbol');

        $input.inputmask({
            mask: 'a9.b9.cd99',
            inputmode: 'numeric',
            placeholder: '_',
            definitions: {
                'a': {
                    validator: "[0-3]"
                },
                'b': {
                    validator: "[01]"
                },
                'c': {
                    validator: "[12]"
                },
                'd': {
                    validator: "[09]"
                }
            },
            onKeyValidation: function (key, result) {
                if (!result && complete === false) {
                    UIInput.prototype.setError($input, $input_error_symbol, true);
                } else {
                    UIInput.prototype.clearError($input);
                }
            },
            onKeyDown: function (key) {
                UIInput.prototype.clearError($input);
                if (key.code === 'Backspace') {
                    complete = false;
                }
            },
            oncomplete: function () {
                complete = true;
            },
            onincomplete: function () {
                complete = false;
            },
            oncleared: function () {
                complete = false;
            }
        });

        if (validation_field !== null) {
            $input.on('blur', function () {
                var $input = $(this);

                if (!that.__validateValue(validation_field, $.trim($input.val()))) {
                    UIInput.prototype.setError($input);
                }
            });
        }
    };

    __setupNameInputsMask = function (force_type = null) {
        var that = this;

        that.$inputs_name.each(function () {
            var $that = $(this),
                input_type = $that.data('type');

            that.__setupNameInputMask($that, force_type || input_type);
        });
    };

    __setupNameInputMask = function ($input, type) {
        var that = this,
            $input_error_text = $input.data('error-text'),
            $input_warning_text = $input.data('warning-character'),
            complete = false,
            pattern;

        if (type === 'cyr') {
            pattern = 'c'
        }
        if (type === 'lat') {
            pattern = 'l'
        }
        if (type === 'both') {
            pattern = 'b'
        }

        $input.inputmask('remove');
        UIInput.prototype.clearInput($input);
        UIInput.prototype.clearError($input);

        $input.inputmask({
            mask: pattern + '{*}',
            definitions: {
                'c': {
                    // cyrillic only, exclude ъЪ 
                    // https://jrgraphix.net/r/Unicode/0400-04FF
                    // last characters: space and minus
                    validator: '[\u0401\u0451\u0410-\u0429\u042B-\u0449\u044B-\u044F -]'
                },
                'l': {
                    // latin only
                    // https://jrgraphix.net/r/Unicode/0020-007F
                    validator: '[\u0041-\u005A\u0061-\u007A]'
                },
                'b': {
                    // both: cyrillic + latin
                    validator: '[\u0041-\u005A\u0061-\u007A\u0401\u0451\u0410-\u0429\u042B-\u0449\u044B-\u044F -]'
                }
            },
            onKeyValidation: function (key, result) {
                if (!result && complete === false) {
                    UIInput.prototype.setError($input, $input_error_text, true);
                    $input.data('set-error-masks', true);
                } else {
                    $input.data('set-error-masks', false);
                }
            },
            onKeyDown: function (key) {
                UIInput.prototype.clearError($input);
                if (key.code === 'Backspace') {
                    complete = false;
                }
                if (key.code === 'Space' || key.code === 'Minus') {
                    UIInput.prototype.setError($input, $input_warning_text, true);
                    $input.data('set-error-masks', true);
                } else {
                    $input.data('set-error-masks', false);
                }
            },
            oncomplete: function () {
                complete = true;
                that.__inputReplace($input);
            },
            onincomplete: function () {
                complete = false;
                that.__inputReplace($input);
            },
            onBeforePaste: function () {
                that.__inputReplace($input);
            },
            oncleared: function () {
                complete = false;
            }
        });
    };

    __setupDocNumberMask = function () {
        var that = this,
            doc_code = that.$input_doc_code.val(),
            $input_error_text = that.$input_doc_number.data('error-text'),

            $input_wrapper = that.$input_doc_number.parents('.input'),
            $input_description = $input_wrapper.find('.description'),
            $input_icon = $input_wrapper.find('.js-icon-visible'),
            $input_icon_sr = $input_wrapper.find('.js-icon-SR'),
            $input_icon_np = $input_wrapper.find('.js-icon-NP'),
            $input_icon_za = $input_wrapper.find('.js-icon-ZA'),
            complete = false;

        that.$input_doc_number.val('');
        UIInput.prototype.clearError(that.$input_doc_number);

        switch (doc_code) {
            case 'PS':
                that.$input_doc_number.inputmask({
                    mask: '9999 999999',
                    placeholder: '_',
                    onKeyValidation: function (key, result) {
                        if (!result && complete === false) {
                            UIInput.prototype.setError(that.$input_doc_number, $input_error_text, true);
                        } else {
                            UIInput.prototype.clearError(that.$input_doc_number);
                        }
                    },
                    onKeyDown: function (key) {
                        UIInput.prototype.clearError(that.$input_doc_number);
                        if (key.code === 'Backspace') {
                            complete = false;
                        }
                    },
                    oncomplete: function () {
                        complete = true;
                    },
                    onincomplete: function () {
                        complete = false;
                    },
                    oncleared: function () {
                        complete = false;
                    }
                });

                $input_description.text(that.$input_doc_number.data('description-ps'));
                $input_icon.prop('hidden', true);
                break;

            case 'SR':
                that.$input_doc_number.inputmask({
                    mask: 'x{1,5}-cc 999999',
                    placeholder: '_',
                    casing: 'upper',
                    definitions: {
                        'x': {
                            validator: '[\u0049\u0069\u0056\u0076\u0058\u0078]'
                        },
                        'c': {
                            validator: '[\u0410-\u044F]'
                        }
                    },
                    onKeyValidation: function (key, result) {
                        if (!result && complete === false) {
                            UIInput.prototype.setError(that.$input_doc_number, $input_error_text, true);
                        } else {
                            UIInput.prototype.clearError(that.$input_doc_number);
                        }
                    },
                    onKeyDown: function (key) {
                        UIInput.prototype.clearError(that.$input_doc_number);
                        if (key.code === 'Backspace') {
                            complete = false;
                        }
                    },
                    oncomplete: function () {
                        complete = true;
                    },
                    onincomplete: function () {
                        complete = false;
                    },
                    oncleared: function () {
                        complete = false;
                    }
                });

                $input_description.text(that.$input_doc_number.data('description-sr'));
                $input_icon.prop('hidden', true);
                $input_icon_sr.prop('hidden', false);
                break;

            case 'PSP':
                $input_description.text(that.$input_doc_number.data('description-psp'));
                $input_icon.prop('hidden', true);

                that.$input_doc_number.inputmask({
                    mask: '99 9999999',
                    placeholder: '_',
                    onKeyValidation: function (key, result) {
                        if (!result && complete === false) {
                            UIInput.prototype.setError(that.$input_doc_number, $input_error_text, true);
                        } else {
                            UIInput.prototype.clearError(that.$input_doc_number);
                        }
                    },
                    onKeyDown: function (key) {
                        UIInput.prototype.clearError(that.$input_doc_number);
                        if (key.code === 'Backspace') {
                            complete = false;
                        }
                    },
                    oncomplete: function () {
                        complete = true;
                    },
                    onincomplete: function () {
                        complete = false;
                    },
                    oncleared: function () {
                        complete = false;
                    }
                });
                
                break;
                
            case 'NP':
            case 'ZA':
                $input_icon.prop('hidden', true);
                
                if (doc_code === 'NP') {
                    $input_description.text(that.$input_doc_number.data('description-np'));
                    $input_icon_np.prop('hidden', false);
                }

                if (doc_code === 'ZA') {
                    $input_description.text(that.$input_doc_number.data('description-za'));
                    $input_icon_za.prop('hidden', false);
                }
                
                that.$input_doc_number.inputmask({
                    mask: 'xxxxxxxxxxxxxx',
                    jitMasking: true,
                    placeholder: '_',
                    definitions: {
                        'x': {
                            validator: '[0-9-_\u0041-\u005A\u0061-\u007A]'
                        }
                    },
                    onKeyValidation: function (key, result) {
                        if (!result && complete === false) {
                            UIInput.prototype.setError(that.$input_doc_number, $input_error_text, true);
                        } else {
                            UIInput.prototype.clearError(that.$input_doc_number);
                        }
                    },
                    onKeyDown: function (key) {
                        UIInput.prototype.clearError(that.$input_doc_number);
                        if (key.code === 'Backspace') {
                            complete = false;
                        }
                    },
                    oncomplete: function () {
                        complete = true;
                    },
                    onincomplete: function () {
                        complete = false;
                    },
                    oncleared: function () {
                        complete = false;
                    }
                });

                break;

            default:
                that.$input_doc_number
                    .inputmask('remove');
                break;
        }

    };

    __disableTextByCheckbox = function ($selector) {
        var that = this;

        $selector.each(function () {
            var $that = $(this),
                $wrapper = $that.parents('.js-checkbox-switch-wrapper'),
                $target = $wrapper.find('.js-checkbox-switch-target');

            $that.on('change', function () {
                if (this.checked) {
                    $target.attr('disabled', 'disabled');
                    // $target_wrapper.removeClass('not-empty');
                    UIInput.prototype.clearInput($target);
                    UIInput.prototype.clearError($target);
                } else {
                    $target.removeAttr('disabled').trigger('input');
                }
            });
        });
    };

    // Handlers

    __initInputInput = function ($input) {
        var that = this;

        if ($input.hasClass('js-citizenship')) {
            that.__setupDocListByCitizenship(that.$input_citizenship.val());
        }
        
        if ($input.hasClass('js-name')) {
            that.__validateNameFieldsSum();
        }

        if ($input.hasClass('js-doc-code') || $input.hasClass('js-citizenship')) {
            that.__validateDocumentAccordingAge(
                that.$input_birthday,
                that.departure_date,
                that.departure_date_last
            );
        }

        if ($input.hasClass('js-input-sex') && that.$input_birthday.data('input_touched')) {
            if (
                that.__validateBirthday(
                that.$input_birthday,
                that.departure_date) &&
                
                that.__validateDocumentAccordingAge(
                    that.$input_birthday,
                    that.departure_date,
                    that.departure_date_last)
            ) {
                UIInput.prototype.clearError(that.$input_birthday);
            }
        }
    };

    __initInputBlur = function ($input) {
        var that = this;

        if ($input.hasClass('js-name')) {
            that.__validateField($input);
        }
        
        if ($input.hasClass('js-input-select')) {
            that.__validateSelectValue($input);
        }
        
        if ($input.hasClass('js-doc-number')) {
            that.__validateField($input, that.$input_doc_code.val());
        }

        if ($input.hasClass('js-birthday')) {
            that.__validateBirthday(
                that.$input_birthday,
                that.departure_date
            );
            
            that.__validateDocumentAccordingAge(
                that.$input_birthday,
                that.departure_date,
                that.departure_date_last
            );

            $input.data('input_touched', true);
        }

        if ($input.hasClass('js-input-expire')) {
            that.__validateExpireDate(
                that.$input_doc_expire,
                that.departure_date_last
            );
        }
    };

    // Actions

    __reset = function () {
        var that = this,
            $select_buttons = that.$wrapper.find('.select-button'),
            $select_button = $select_buttons.find(`.${that.class.reset_input}`),
            $checkboxes = that.$wrapper.find(`.checkbox .${that.class.reset_input}`),
            $inputs = that.$wrapper.find(`.input .${that.class.reset_input}`),
            $selects = that.$wrapper.find(`.select .${that.class.reset_input}`),
            $alerts = that.$wrapper.find('.js-alert');

        $select_buttons.removeClass('error');
        $select_button.prop('checked', false).change();
        $checkboxes.prop('checked', false).change();

        //
        $inputs.val('');
        $inputs.each(function () {
            var $input = $(this);
            UIInput.prototype.clearError($input);
            $input.data('input_touched', false);
        });

        //
        $selects.each(function () {
            var $select = $(this);
            UISelect.prototype.__clearValue($select);
        });

        //
        $alerts.each(function () {
            that.__alertClose($(this));
        });
        
        if (that.passenger_form_ssrs) {
            that.passenger_form_ssrs.reset();
        }
    };

    __togglePspExpireField = function (enabled = false) {
        var that = this;

        if (!that.$doc_expire_wrapper.length || !that.$input_doc_expire.length) {
            return false;
        }

        var $input_wrapper = that.$input_doc_expire.parents('.input'),
            $input_wrapper_field = $input_wrapper.parents('.field');

        if (enabled) {
            that.$input_doc_expire.prop('disabled', false);
            that.$input_doc_expire.inputmask('remove').val('');
            $input_wrapper_field.removeClass('hidden-mobile');
            that.__setupDateMask(that.$input_doc_expire, 'expire');
        } else {
            that.$input_doc_expire.prop('disabled', true);
            that.$input_doc_expire.inputmask('remove').val('');
            $input_wrapper.removeClass('not-empty');
            $input_wrapper_field.addClass('hidden-mobile');
            that.__alertClose(that.$wrapper.find('.js-alert-expire'));
        }
    };

    __inputReplace = function ($input) {
        var cursor_position = $input.prop('selectionStart');

        $input.val($input.val().replace(/[ -]/gm, ''));
        $input.val($input.val().replace(/ё/gm, 'е'));
        $input.val($input.val().replace(/Ё/gm, 'Е'));
        $input.val($input.val().replace(/^[ьЬ]*/gm, ''));

        $input
            .prop('selectionStart', cursor_position)
            .prop('selectionEnd', cursor_position);
    };

    __setupDocListByCitizenship = function (citizenship) {
        var that = this,
            $doc_list = that.$doc_select.find('.select-options .list'),
            $international = $doc_list.find('.js-international'),
            $needs_citizenship = $doc_list.find('.js-needs_citizenship');
        
        if (citizenship === $.sa.nationality) {
            $needs_citizenship
                .show()
                .data('hidden', false);
            $international
                .hide()
                .data('hidden', true);
            
            UISelect.prototype.selectOption(that.$doc_select, $needs_citizenship.first());

        } else {
            $needs_citizenship
                .hide()
                .data('hidden', true);
            $international
                .show()
                .data('hidden', false);

            UISelect.prototype._selectOption(that.$doc_select, $international.first());
        }
    };

    // Validate methods

    __validate = function (departure_date, departure_date_last) {
        var that = this,
            $select_buttons = that.$wrapper.find('.js-select-button'),
            is_valid = true;

        $select_buttons.each(function () {
            if (!that.__validateSelectButtons($(this))) {
                is_valid = false;
            }
        });

        that.$inputs_select.each(function () {
            if (!that.__validateSelectValue($(this))) {
                is_valid = false;
            }
        });

        if (!that.__validateField(that.$input_doc_number, that.$input_doc_code.val())) {
            is_valid = false;
        }

        if (!that.__validateExpireDate(that.$input_doc_expire, departure_date_last)) {
            is_valid = false;
        }

        that.$inputs_name.each(function () {
            if (!that.__validateField($(this))) {
                is_valid = false;
            }
        });

        if (!that.__validateNameFieldsSum()) {
            is_valid = false;
        }

        if (!that.__validateBirthday(that.$input_birthday, departure_date)) {
            is_valid = false;
        }

        if (!that.__validateDocumentAccordingAge(that.$input_birthday, departure_date, departure_date_last)) {
            is_valid = false;
        }

        return is_valid;
    };

    __validateExpireDate = function ($input, departure_date_last) {
        var that = this,
            expire = $input.val(),
            expire_trim = expire.replace(/[^0-9]/g, ''),
            expire_formatted = dayjs(expire, 'DD.MM.YYYY', true),
            departure_date_last_formatted = dayjs(departure_date_last, 'YYYY-MM-DD HH:mm:ss', true),
            error_text = $input.data('error-text'),
            error_expire = $input.data('error-expire'),
            date_diff = 0,

            $alert_wrapper = that.$wrapper.find('.js-alert-expire'),

            is_valid = true;

        that.__alertClose($alert_wrapper);

        if ($input.prop('disabled')) {
            return true;
        }

        if (expire_trim.length < 8) {
            UIInput.prototype.setError($input, error_text, true);
            return false;
        }

        if (expire_trim.length === 8) {
            date_diff = expire_formatted.diff(departure_date_last_formatted, 'day');

            if (date_diff < 0) {
                UIInput.prototype.setError($input, error_expire, true);
                that.__alertShow($alert_wrapper);
                is_valid = false;
            }
        }

        return is_valid;
    };

    __validateNameFieldsSum = function () {
        var that = this,
            $inputs_name = that.$wrapper.find('.js-name'),
            $alert_wrapper = that.$wrapper.find('.js-alert-limit-characters'),
            doc_code = that.$wrapper.find('.js-doc-code').val() || 'PS',
            input_type = 'cyr',

            input_value_count = 0,
            is_valid = false;

        if (doc_code !== 'PS' && doc_code !== 'SR') {
            input_type = 'lat';
        }

        $inputs_name.each(function () {
            var $input = $(this);
            input_value_count = input_value_count + $input.val().length;
        });

        if (input_type === 'cyr') {
            if (input_value_count <= 43) {
                is_valid = true
            }
        } else {
            if (input_value_count <= 50) {
                is_valid = true
            }
        }

        that.__alertClose($alert_wrapper);

        $inputs_name.each(function () {
            var $input = $(this),
                error_text = $input.data('limit-characters');

            if ($input.val().length > 0) {
                if (!is_valid) {
                    UIInput.prototype.setError($input, error_text, true);
                    $input.data('set-error', true);
                    that.__alertShow($alert_wrapper);
                } else {
                    if (!$input.data('set-error-masks')) {
                        UIInput.prototype.clearError($input);
                        $input.data('set-error', false);
                    }
                }
            }
        });

        return is_valid;
    };
    
    __validateDocumentAccordingAge = function ($input, departure_date, departure_date_last) {
        var that = this,
            citizenship = that.$wrapper.find('.js-citizenship').val() || 'RU',
            doc_code = that.$wrapper.find('.js-doc-code').val() || 'PS',

            birthday = $input.val(),
            birthday_trim = birthday.replace(/[^0-9]/g, ''),
            birthday_formatted = dayjs(birthday, 'DD.MM.YYYY', true),
            departure_date_formatted = dayjs(departure_date, 'YYYY-MM-DD HH:mm:ss', true),
            departure_date_last_formatted = dayjs(departure_date_last, 'YYYY-MM-DD HH:mm:ss', true),

            birthday_14y = 0,
            birthday_14y_90d = 0,
            date_diff_ps = 0,
            date_diff_sr = 0,
            date_back_diff_sr = 0,

            $alert_wrapper = that.$wrapper.find('.js-alert-document'),
            error_text = $input.data('error-passenger-age'),

            allow_ps = true,
            allow_sr = true,
            is_valid = true;

        if (birthday_trim.length === 8) {
            // https://day.js.org/docs/en/display/difference
            date_diff_ps = departure_date_formatted.diff(birthday_formatted, 'year', true);

            // if passenger older than 12 and younger than 14 years old
            if (date_diff_ps >= 12 && date_diff_ps <= 13.999999999999999) {
                allow_ps = false;
            }

            // if passenger older than 14 years plus 90 days
            // https://day.js.org/docs/en/manipulate/add
            birthday_14y = birthday_formatted.add(14, 'year');
            birthday_14y_90d = birthday_14y.add(91, 'day');

            date_diff_sr = birthday_14y_90d.diff(departure_date_formatted, 'day', true);
            date_back_diff_sr = birthday_14y_90d.diff(departure_date_last_formatted, 'day', true);

            if (date_diff_sr < 0) {
                allow_sr = false;
            }
            if (date_back_diff_sr < 0) {
                allow_sr = false;
            }

            $input.data('input_valid_according_age', false);
            if (that.__validateBirthday($input, departure_date)) {
                UIInput.prototype.clearError($input);
            }
        }

        if (citizenship !== 'RU') {
            allow_ps = true;
            allow_sr = true;
        }

        that.__alertClose($alert_wrapper);

        if (!allow_ps && doc_code === 'PS') {
            that.__alertShow($alert_wrapper);
            UIInput.prototype.setError($input, error_text, true);
            $input.data('input_valid_according_age', true);
            is_valid = false;
        }

        if (!allow_sr && doc_code === 'SR') {
            that.__alertShow($alert_wrapper);
            UIInput.prototype.setError($input, error_text, true);
            $input.data('input_valid_according_age', true);
            is_valid = false;
        }

        return is_valid;
    };

    __validateBirthday = function ($input, departure_date) {
        var that = this,
            $sex = that.$wrapper.find('.js-select-sex'),
            sex_value = $sex.find('.js-select-button-input:checked').val(),
            sex_error_text = $sex.data('error-text'),
            passenger_code = that.$wrapper.find('.js-passenger-category-code').val(),
            error_text = $input.data('error-text'),
            error_text_cat = $input.data('error-passenger-cat'),
            error_text_sex = $input.data('error-sex'),

            birthday = $input.val(),
            birthday_trim = birthday.replace(/[^0-9]/g, ''),
            birthday_formatted = dayjs(birthday, 'DD.MM.YYYY', true),
            departure_date_formatted = dayjs(departure_date, 'YYYY-MM-DD HH:mm:ss', true),
            datetime_now = dayjs.utc($.sa.server_datetime, 'YYYY-MM-DD HH:mm:ss', true),
            date_before = dayjs.utc('01.01.1900', 'DD.MM.YYYY', true),

            ask_future = that.locales['ask_future'],
            random_index = Math.floor(Math.random() * ask_future.length),
            random_ask_future = ask_future[random_index],

            valid_date_birth = birthday_formatted.isValid(),

            // https://day.js.org/docs/en/display/difference
            date_diff = departure_date_formatted.diff(birthday_formatted, 'year', true),
            date_diff_now = datetime_now.diff(birthday_formatted, 'day', true),

            years_min = 0,
            years_max = 200,
            is_valid = true;
        
        if (!$input.data('input_valid_according_age')) {
            UIInput.prototype.clearError($input);
        }

        if (!sex_value && passenger_code === 'SRC') {
            $sex
                .addClass('error')
                .find('.js-error-content')
                .text(sex_error_text);

            UIInput.prototype.setError($input, error_text_sex, true);
            return false;
        }

        if (
            !birthday ||
            !valid_date_birth ||
            birthday_trim.length < 8
        ) {
            UIInput.prototype.setError($input, error_text, true);
            return false;
        }

        switch (passenger_code) {
            case 'INF':
            case 'INS':
                years_max = 1.999999999999999;
                break;

            case 'CHD':
                years_min = 2;
                years_max = 11.999999999999999;
                break;

            case 'CNN':
                years_min = 2;
                years_max = 11.999999999999999;
                break;

            case 'ADT':
                years_min = 12;
                break;

            case 'YTH':
                years_min = 12;
                years_max = 22.999999999999999;
                break;

            case 'SRC':
                if (sex_value === 'female') {
                    years_min = 55;
                }
                if (sex_value === 'male') {
                    years_min = 60;
                }
                break;
        }

        if (!((years_min <= date_diff) && (date_diff <= years_max))) {
            UIInput.prototype.setError($input, error_text_cat, true);
            is_valid = false;
        }

        if (date_diff_now < 1) {
            UIInput.prototype.setError($input, random_ask_future, true);
            is_valid = false;
        }

        return is_valid;
    };

    __validateSelectValue = function ($select) {
        var that = this,
            $input = $select.find('.js-input'),
            value = $input.val(),
            error_empty = $input.data('error-empty'),
            is_valid = true;
        
        if (!value) {
            that.__setSelectError($select, error_empty);
            is_valid = false;
        }
        
        return is_valid;
    };

    __validateField = function ($input, doctype = 'empty') {
        var that = this,
            value = $input.val(),
            error_empty = $input.data('error-empty'),
            error_wrong = $input.data('error-wrong'),
            value_trim = value.replace(/[- _]/g, ''),
            value_length,
            is_valid = true;

        if (!$input.data('set-error')) {
            UIInput.prototype.clearError($input);
        }

        if ($input.prop('disabled')) {
            return true;
        }

        switch (doctype) {
            case 'PS':
                value_length = 10;
                break

            case 'SR':
                // At least one character must be entered in first section
                value_trim = value_trim.replace(/[\u0049\u0069\u0056\u0076\u0058\u0078]{1,5}/g, 'I');
                value_length = 9;
                break

            case 'PSP':
                value_length = 9;
                break

            case 'NP':
            case 'ZA':
            case 'empty':
                value_length = 1;
                value_trim = value.replace('_', '');

        }

        if (value_trim.length < 1) {
            UIInput.prototype.setError($input, error_empty, true);
            is_valid = false;
        } else if (value_trim.length < value_length) {
            UIInput.prototype.setError($input, error_wrong, true);
            is_valid = false;
        }

        return is_valid;
    };

    __validateValue = function (field, value) {
        var that = this,
            datetime_now = dayjs.utc($.sa.server_datetime, 'YYYY-MM-DD HH:mm:ss', true);

        switch (field) {
            case 'birthday':
                var date_birth = dayjs.utc(value, 'DD.MM.YYYY', true),
                    date_before = dayjs.utc('01.01.1900', 'DD.MM.YYYY', true),
                    valid_date_birth = date_birth.isValid(),
                    // https://day.js.org/docs/ru/plugin/is-between
                    valid_date_between = date_birth.isBetween(date_before, datetime_now, 'day', '[]');

                if (!valid_date_birth || !valid_date_between) {
                    return false;
                }
                break;

            case 'expire':
                var date_expire = dayjs.utc(value, 'DD.MM.YYYY', true),
                    valid_date_expire = date_expire.isValid();

                if (!valid_date_expire) {
                    return false;
                }
                break;
        }

        return true;
    };

    __validateSelectButtons = function ($button) {
        var that = this,
            $inputs = $button.find('.js-select-button-input'),
            error_text = $button.data('error-text'),
            is_valid = false;

        $inputs.each(function () {
            if ($(this).prop('checked')) {
                is_valid = true;
            }
        });

        if (!is_valid) {
            $button
                .addClass('error')
                .find('.js-error-content')
                    .text(error_text)
                    .attr("title", error_text);
        }

        return is_valid;
    };
    
    // Helpers

    __alertShow = function ($alert_wrapper) {
        var that = this;
        $alert_wrapper.show();
    };

    __alertClose = function ($alert_wrapper) {
        var that = this;
        $alert_wrapper.hide();
    };

    __setSelectError = function ($select, error_text) {
        var that = this,
            $select_input_error = $select.find('.error');

        $select.addClass(that.class.error);
        $select_input_error.text(error_text).attr("title", error_text);
    };
}